import React, { createContext, useContext, useState, useEffect } from 'react';
import { getSystemControls } from '../lib/settings';

const SettingsContext = createContext({
  controls: {
    enable_whatsapp: true,
    enable_pdf_export: true,
    enable_audit_logs: true,
    enable_validation_alerts: true,
    enable_notifications: true
  },
  loading: true,
  refresh: () => {}
});

export const SettingsProvider = ({ children }) => {
  const [controls, setControls] = useState({
    enable_whatsapp: true,
    enable_pdf_export: true,
    enable_audit_logs: true,
    enable_validation_alerts: true,
    enable_notifications: true
  });
  const [loading, setLoading] = useState(true);

  const fetchControls = async () => {
    const data = await getSystemControls();
    setControls(data);
    setLoading(false);
  };

  useEffect(() => {
    fetchControls();
  }, []);

  return (
    <SettingsContext.Provider value={{ controls, loading, refresh: fetchControls }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
